define('lq/events/actions/breakEvent',[
    'lq/events/actions/eventAction'
], function (EventAction) {
    'use strict';

    function BreakEvent(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
    }

    EventAction.extend(BreakEvent, EventAction);

    BreakEvent.typeName = 'BreakEvent';

    BreakEvent.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };

    BreakEvent.prototype.execute = function (continuation, eventActionResponse) {
        this.piping.busyIndicator.forceHide();
    };

    return BreakEvent;
});
